export default {
  title: '{asset} an Datenquelle anschließen',
};
